/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllRecordLookups = require('../../common/services/GetAllRecordLookups');

var CorpFinExtCreateFilingView = require('../views/CorpFinExtCreateFilingView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  GetAllRecordLookups()
    .done(function(recordLookups) {
      NavUtils.navigate('ext/corpfin/new-filing');
      Scaffold.content.show(
        new CorpFinExtCreateFilingView({
          model: new Backbone.Model({
            filingApplicationTypes: recordLookups.filingApplicationTypes,
            filingTypes: recordLookups.filingTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
